<template>
  <div>
    <div class="wz-page-header">
      <h1 class="wz-page-title">Tipos de licencia</h1>
    </div>

    <wz-table-container>
      <wz-table-toolbar>
        <template #right>
          <wz-tooltip text="Recargar">
            <wz-button variant="outline" @click="loadData()">
              <i class="ri-loop-right-line"></i>
            </wz-button>
          </wz-tooltip>
          <wz-search-bar
            placeholder="Buscar por nombre o código"
            @input="search = $event"
            @search="search = $event"
          />
          <wz-button @click="$router.push({ name: 'leave-type-create' })">Agregar</wz-button>
        </template>
      </wz-table-toolbar>

      <wz-table>
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Código</th>
            <th style="text-align: right;">Días</th>
            <th>Remunerado</th>
            <th>Legal</th>
            <th>Estado</th>
            <th>Opciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="filteredList.length === 0">
            <td colspan="7" class="text-center text-muted py-4">No se encontraron resultados.</td>
          </tr>
          <tr v-for="o in filteredList" :key="o.id">
            <td>{{ o.name }}</td>
            <td>{{ o.code }}</td>
            <td style="text-align: right;">{{ o.defaultDays != null ? o.defaultDays : '-' }}</td>
            <td>{{ o.isRemunerated ? 'Sí' : 'No' }}</td>
            <td>
              <wz-badge v-if="o.isLegal" variant="primary" pill>Legal</wz-badge>
              <span v-else class="text-muted">—</span>
            </td>
            <td>
              <wz-badge :variant="o.status === 1 ? 'success-solid' : 'dark'" pill>
                {{ o.status === 1 ? 'ACTIVO' : 'INACTIVO' }}
              </wz-badge>
            </td>
            <td style="text-align: center;">
              <wz-dropdown
                :items="rowActions(o)"
                placement="left"
                @click="handleAction(o, $event)"
              />
            </td>
          </tr>
        </tbody>
      </wz-table>

      <wz-table-footer>
        <span>{{ filteredList.length }} registro(s)</span>
      </wz-table-footer>
    </wz-table-container>

    <wz-confirm-modal
      v-model="confirmModal.show"
      :title="confirmModal.title"
      :description="confirmModal.description"
      :accept-text="confirmModal.acceptText"
      :cancel-text="confirmModal.cancelText"
      @confirm="onModalConfirm"
      @cancel="closeConfirmModal"
    />
  </div>
</template>

<script>
import { Alert, ConfirmModalMixin } from '@wizepe/wizeui'
import { LeaveTypeService } from '@/core/services'

export default {
  mixins: [ConfirmModalMixin],
  data() {
    return {
      list: [],
      search: '',
      selectedOption: null,
    }
  },
  computed: {
    filteredList() {
      let result = this.list
      if (this.search) {
        const q = this.search.toLowerCase()
        result = result.filter(o =>
          (o.name || '').toLowerCase().includes(q) || (o.code || '').toLowerCase().includes(q))
      }
      return result
    },
  },
  methods: {
    rowActions(o) {
      // Los tipos legales no se editan ni eliminan, solo se activa/desactiva
      if (o.isLegal) {
        return [{ key: 'status', label: o.status === 1 ? 'Desactivar' : 'Activar' }]
      }
      return [
        { key: 'edit',   label: 'Editar' },
        { key: 'status', label: o.status === 1 ? 'Desactivar' : 'Activar' },
        { key: 'delete', label: 'Eliminar', danger: true },
      ]
    },
    handleAction(o, item) {
      if (item.key === 'edit')   this.$router.push({ name: 'leave-type-edit', params: { id: o.id } })
      if (item.key === 'status') this.openChangeStatus(o)
      if (item.key === 'delete') this.openDelete(o)
    },
    async loadData() {
      try {
        await this.$store.dispatch('app/loading', true)
        this.list = (await LeaveTypeService.list()).payload || []
      } catch (e) {
        console.error(e)
        Alert.error('Error al cargar los tipos de licencia')
      } finally {
        await this.$store.dispatch('app/loading', false)
      }
    },
    openChangeStatus(o) {
      this.selectedOption = o
      this.openConfirmModal({
        title:       'Cambiar estado',
        description: '¿Está seguro que desea cambiar el estado de este tipo de licencia?',
        acceptText:  'Aceptar',
        action:      'status',
      })
    },
    openDelete(o) {
      this.selectedOption = o
      this.openConfirmModal({
        title:       'Eliminar tipo de licencia',
        description: `¿Está seguro que desea eliminar "${o.name}"?`,
        acceptText:  'Eliminar',
        action:      'delete',
      })
    },
    onModalConfirm() {
      const action = this.confirmModal.action
      this.closeConfirmModal()
      if (action === 'status') this.changeStatus()
      if (action === 'delete') this.deleteType()
    },
    async changeStatus() {
      try {
        await this.$store.dispatch('app/loading', true)
        const newStatus = this.selectedOption.status === 1 ? 0 : 1
        await LeaveTypeService.changeStatus(this.selectedOption.id, newStatus)
        await this.loadData()
        Alert.success('Estado actualizado correctamente')
      } catch (ex) {
        console.error(ex)
        Alert.error(ex.errors ? ex.errors.message : 'Error al cambiar el estado')
      } finally {
        await this.$store.dispatch('app/loading', false)
      }
    },
    async deleteType() {
      try {
        await this.$store.dispatch('app/loading', true)
        await LeaveTypeService.remove(this.selectedOption.id)
        await this.loadData()
        Alert.success('Tipo de licencia eliminado correctamente')
      } catch (ex) {
        console.error(ex)
        Alert.error(ex.errors ? ex.errors.message : 'Error al eliminar')
      } finally {
        await this.$store.dispatch('app/loading', false)
      }
    },
  },
  async created() {
    await this.loadData()
  },
}
</script>

<style lang="stylus"></style>
